






























import { Component, Vue } from 'vue-property-decorator';
import { KycRequests } from '@/api';
import { KycOrgConfig, GeneralDoc } from '@/api/auth';
import IdDocType from '@/resources/enum/IdDocType';
import MnDocType from '@/resources/enum/MnDocType';
import GpDocTypePassVaccine from '@/resources/enum/GpDocTypePassVaccine';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import PageHeader from '@/components/PageHeader.vue';
import TopFooterButton from '@/components/TopFooterButton.vue';
import TopContentText from '@/components/TopContentText.vue';
import TopContentCautionSingle from '@/components/TopContentCautionSingle.vue';
import TopContentSelectGpDoc from '@/components/TopContentSelectGpDoc.vue';

@Component({
  components: {
    PageHeader,
    TopFooterButton,
    TopContentText,
    TopContentCautionSingle,
    TopContentSelectGpDoc
  }
})
export default class PersonalInformation extends Vue {
  private isLoading: boolean = false;
  private gpDocTypeId: string = 'unknown';

  private get selectGpDocList(): {
    key: string;
    page: number;
    text1: string;
    text2: string;
    text3: string;
    srcset: string[] | null;
  }[] {
    if (!this.$store.getters['auth/isCollectGpDoc']) return [];

    const key: string = 'topPersonalInformation.generalPurposeDocumentMaximumNumberOfPhotos';
    const locale: string = this.$store.getters['i18n/locale'];
    let generalDocs: GeneralDoc[] = this.$store.getters['auth/generalDocs'];
    generalDocs = Array.from(generalDocs).sort((a, b): number => a.displayPriority - b.displayPriority);
    return generalDocs.map(generalDoc => ({
      key: generalDoc.generalDocType,
      page: generalDoc.maxPages,
      text1: generalDoc.generalDocName[locale],
      text2: this.$t(key, { num: generalDoc.maxPages }) as string,
      text3: generalDoc.description[locale],
      srcset: ((): string[] | null => {
        let key: string = '';
        const gpDocType: string = generalDoc.generalDocType;
        if (gpDocType === GpDocTypePassVaccine.SecondRecord) key = 'secondRecord';
        if (gpDocType === GpDocTypePassVaccine.SecondCertificate) key = 'secondCertificate';
        if (gpDocType === GpDocTypePassVaccine.ThirdCertificate) key = 'thirdCertificate';
        if (gpDocType === GpDocTypePassVaccine.ThirdInoculation) key = 'thirdInoculation';
        return [
          this.$t(`passVaccine.gpDoc.${key}.imageSelectDocument${1}`) as string,
          this.$t(`passVaccine.gpDoc.${key}.imageSelectDocument${2}`) as string,
          this.$t(`passVaccine.gpDoc.${key}.imageSelectDocument${3}`) as string,
          this.$t(`passVaccine.gpDoc.${key}.imageSelectDocument${4}`) as string
        ];
      })()
    }));
  }

  private get selectGpDocListFirst() {
    return this.selectGpDocList.filter((selectGpDocData): boolean => {
      if (selectGpDocData.key === GpDocTypePassVaccine.SecondRecord) return true;
      if (selectGpDocData.key === GpDocTypePassVaccine.SecondCertificate) return true;
      return false;
    });
  }

  private get selectGpDocListSecond() {
    return this.selectGpDocList.filter((selectGpDocData): boolean => {
      if (selectGpDocData.key === GpDocTypePassVaccine.ThirdCertificate) return true;
      if (selectGpDocData.key === GpDocTypePassVaccine.ThirdInoculation) return true;
      return false;
    });
  }

  // 初期化処理
  private async created() {
    window.scrollTo({ top: 0 });

    // 汎用書類のデフォルトの選択
    const currentGpDocType: string = this.$store.getters['camera/gpDocType'];
    if (currentGpDocType !== 'unknown') {
      this.gpDocTypeId = currentGpDocType;
    } else if (this.selectGpDocListFirst.length > 0) {
      this.gpDocTypeId = this.selectGpDocListFirst[0].key;
    } else if (this.selectGpDocListSecond.length > 0) {
      this.gpDocTypeId = this.selectGpDocListSecond[0].key;
    }
  }

  // 次のページへ行く
  private async next(): Promise<void> {
    const kycOrgConfig: KycOrgConfig = this.$store.getters['auth/kycOrgConfig'];

    try {
      this.isLoading = true;
      const kycRequestId: number = this.$store.getters['auth/kycRequestID'];
      const isFetchClientTypes: boolean = kycOrgConfig.enableClientTypePC;
      if (isFetchClientTypes) await KycRequests.fetchClientTypes(kycRequestId, this.$store.getters['camera/isPC']);
      await KycRequests.fetchIdDocTypes(kycRequestId, { idDocType: IdDocType.GpGeneral });
      await KycRequests.fetchGpDocTypes(kycRequestId, { generalDocType: this.gpDocTypeId });
      const gpDocPage: number = this.selectGpDocList.find(data => data.key === this.gpDocTypeId)?.page || 0;
      this.$store.commit('camera/setIdDocType', IdDocType.GpGeneral);
      this.$store.commit('camera/setMnDocType', MnDocType.Unknown);
      this.$store.commit('camera/setGpDocType', this.gpDocTypeId);
      this.$store.commit('camera/setGpDocPageLast', gpDocPage);
      this.$store.commit('camera/setOpDocType', []);
      this.$store.commit('camera/isDetectableIdDoc', false);
      this.$store.commit('camera/isDetectStop', false);
      this.$store.commit('camera/resetRetryCount');
      this.$router.push(this.$store.getters['camera/locationFirst']);
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isLoading = false;
    }
  }
}
